import { Typo3SectionSpotHeadlessInfoSlider } from '@/types/typo3'

const toSectionInfo = ({
  section
}: {
  section: Typo3SectionSpotHeadlessInfoSlider
}) => ({
  section: section,
  sectionHeaderData: {
    title: section?.title,
    titleLayout: section?.titleLayout,
    overline: section?.overline
  },
  items: section?.items?.map((item) => ({
    title: item.title,
    icon: item.icon,
    image: item?.image,
    description: item?.description,
    links: item?.links?.map((link) => ({
      href: link?.href,
      title: link?.title,
      icon: link?.icon,
      target: link?.target,
      location: link?.subtitle
    }))
  }))
})

export default toSectionInfo
